import _ from 'lodash'
import {basicContext} from "../../utils/contextUtils";
import {
    fetchDtData,
    GET_OBJECT_SUCCESS,
    CREATE_OBJECT_SUCCESS,
    SAVE_OBJECT_SUCCESS
} from "../../../apps/KpModule/actions/api";
import {changeFieldProperty, setDataList, setFieldVisibility} from "../../../apps/KpModule/actions";
import async from "async";
import Errors from "../../utils/Errors";
import moment from "moment";
import {findStoredItem} from "../../enhancers/facets";

const returnButton = {
    type: 'return',
    tKey: 'return',
    bsStyle: 'default'
}

const saveButton = {
    type: 'save',
    tKey: 'save',
    bsStyle: 'success'
}

function generateKeepForOneYearButton(date){
    let nextDate = moment(date)

    while (nextDate.isValid() && !nextDate.isAfter(moment())) {
        nextDate.add(1, 'year')
    }

    return {
        action: 'keepForOneYear',
        bsStyle: 'primary',
        tKey: !date ? "keepForOneYear" : "Me le rappeler à partir du : " + nextDate?.format('DD-MM-YYYY'),
        type: 'action'
    }
}

function isObjectExpired(object) {
    const currentDay = moment().startOf('day');
    return currentDay.isAfter(object.keepUntilDate)
}

export const jobs = () => []
export const entities = () =>[
    {
        name: "UploadedFileName",
        type: 'mongoInternal',
        fields: [
            'filename',
            'type',
            'date',
            'User',
            {path: 'poster', type: 'object', nullable: true}
        ]
    },
    {
        name: 'MediaTag',
        fields: [
            { path: 'name', unique: true },
        ],
        filters: [
            {
                name: "byUser",
                isDefault: false,
                async: true,
                query: function(context, callback) {
                    global.app[context.model.id].MediaBase.find({
                        query: {},
                        filters: ['onlyActiveStatus', 'byProfile'],
                        fieldPath: ['tags.id'],
                        ...basicContext(context),
                    }, (error, elements) => {
                        const uniqTags = _(elements).flatMap(element => element.tags.map(tag => tag.id)).uniq().value()
                        return callback(error, {_id: {$in: uniqTags.map(id => new global.ObjectID(id))}} )
                    })
                }
            },
        ]
    },
    {
        name: 'FileType',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'img', name: 'image' },
            { id: 'vid', name: 'video' },
            { id: 'doc', name: 'document' }
        ]
    },
    {
        name: 'WidthOption',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'full', name: 'fr:: Pleine largeur\nen:: Full width' },
            { id: 'half', name: 'fr:: Moitié de la largeur\nen:: Half width' },
        ]
    },
    {
        name: 'MediaStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'act', name: 'actif' },
            { id: 'inact', name: 'inactif' },
        ]
    },
    {
        name: 'Image',
        fields: [
            {path: 'name', notEmpty: true},
            'type',
            {
                path: 'user', type: 'User',
                ps: {object: [function(user, image) {
                    // Uploader comes from the authenticated session, never from the
                    // client. An already persisted image keeps its stored uploader,
                    // found by id.
                    const contextUser = this.options.context && this.options.context.user
                    if(!contextUser || !this.options.$v) return user
                    const oldObject = this.options.context.businessOldObject
                    const storedImage = image && image.id && oldObject && findStoredItem(oldObject, image.id)
                    if(storedImage && storedImage.user) return storedImage.user
                    return {id: contextUser.id, name: contextUser.name}
                }]}
            },
            {
                path: 'date', notEmpty: true,
                ps: {object: [function(date, image) {
                    // Never trust a client-supplied date. An already persisted image
                    // keeps its stored date (found by id); anything else is stamped
                    // from the server clock on the authoritative save pass.
                    const now = () => moment().format("YYYY-MM-DD HH:mm:ss")
                    if(!this.options.$v) return date || now()
                    const oldObject = this.options.context && this.options.context.businessOldObject
                    const storedImage = image && image.id && oldObject && findStoredItem(oldObject, image.id)
                    return (storedImage && storedImage.date) || now()
                }]}
            }
        ]
    },
    {
        name: 'Video',
        fields: [
            {path: 'name', notEmpty: true},
            'type',
            {
                path: 'user', type: 'User',
                ps: {object: [function(user, video) {
                    // Uploader comes from the authenticated session, never from the
                    // client. An already persisted video keeps its stored uploader,
                    // found by id.
                    const contextUser = this.options.context && this.options.context.user
                    if(!contextUser || !this.options.$v) return user
                    const oldObject = this.options.context.businessOldObject
                    const storedVideo = video && video.id && oldObject && findStoredItem(oldObject, video.id)
                    if(storedVideo && storedVideo.user) return storedVideo.user
                    return {id: contextUser.id, name: contextUser.name}
                }]}
            },
            {path: 'poster', type: 'object', nullable: true}, // temporary solution
            //{path: 'poster', type: 'Image', nullable: true},
            {
                path: 'date', notEmpty: true,
                ps: {object: [function(date, video) {
                    // Never trust a client-supplied date. An already persisted video
                    // keeps its stored date (found by id); anything else is stamped
                    // from the server clock on the authoritative save pass.
                    const now = () => moment().format("YYYY-MM-DD HH:mm:ss")
                    if(!this.options.$v) return date || now()
                    const oldObject = this.options.context && this.options.context.businessOldObject
                    const storedVideo = video && video.id && oldObject && findStoredItem(oldObject, video.id)
                    return (storedVideo && storedVideo.date) || now()
                }]}
            }
        ]
    },
    {
        name: "MediaBase",
        facets: [
            {name: 'files'},
            {name: 'comments'},
        ],
        fields: [
            {path: "title", unique: true, uniqueWith: 'fileType'}, //
            {path: "description", tKey: 'presentation'},
            {path: "createdAt", type: 'date', dateFormat: "YYYY-MM-DD HH:mm:ss", nullable: true},
            {path: "lastUpdate", type: 'date', dateFormat: "YYYY-MM-DD HH:mm:ss", nullable: true},
            {path: 'keepUntilDate', type: 'date', dateFormat: "YYYY-MM-DD", nullable: true},
            {path: "lastUpdatedBy", type: 'User', nullable: true},
            {
                path: 'images', type: 'Image', link: {type: 'OTM', deleteType: 'cascade', onParent: true},
                ps: {object: [function(images) {
                    // Once an image is persisted, none of its properties (name, date,
                    // user) are client-editable through this field: only adding a
                    // brand new image or removing an existing one (replacing the
                    // media's photo) is a real feature. So every image carrying a
                    // known id is replaced wholesale by its stored version; dropped
                    // ids are not re-appended, since removal is legitimate here.
                    if(! this.options.$v) return images; // not the authoritative save pass
                    const fieldPath = this.norm && this.norm.path;
                    const oldImages = fieldPath && _.get(this.options.context, ["businessOldObject", fieldPath]);
                    if(! _.isArray(oldImages) || ! oldImages.length) return images;
                    const oldById = _.keyBy(oldImages.filter(i => i && i.id), "id");
                    return (_.isArray(images) ? images : []).map(i => (i && i.id && oldById[i.id]) ? oldById[i.id] : i);
                }]}
            },
            {
                path: 'imagesForFiles', type: 'Image', link: {type: 'OTM', deleteType: 'cascade', onParent: true},
                ps: {object: [function(images) {
                    // Once an image is persisted, none of its properties (name, date,
                    // user) are client-editable through this field: only adding a
                    // brand new image or removing an existing one (replacing the
                    // media's photo) is a real feature. So every image carrying a
                    // known id is replaced wholesale by its stored version; dropped
                    // ids are not re-appended, since removal is legitimate here.
                    if(! this.options.$v) return images; // not the authoritative save pass
                    const fieldPath = this.norm && this.norm.path;
                    const oldImages = fieldPath && _.get(this.options.context, ["businessOldObject", fieldPath]);
                    if(! _.isArray(oldImages) || ! oldImages.length) return images;
                    const oldById = _.keyBy(oldImages.filter(i => i && i.id), "id");
                    return (_.isArray(images) ? images : []).map(i => (i && i.id && oldById[i.id]) ? oldById[i.id] : i);
                }]}
            },
            {
                path: 'videos', type: 'Video', link: {type: 'OTM', deleteType: 'cascade', onParent: true},
                ps: {object: [function(videos) {
                    // Once a video is persisted, none of its properties (name, date,
                    // user) are client-editable through this field: only adding a
                    // brand new video or removing an existing one (replacing the
                    // media's video) is a real feature. So every video carrying a
                    // known id is replaced by its stored version, except for its poster;
                    // dropped ids are not re-appended, since removal is legitimate here.
                    if(! this.options.$v) return videos; // not the authoritative save pass
                    const fieldPath = this.norm && this.norm.path;
                    const oldVideos = fieldPath && _.get(this.options.context, ["businessOldObject", fieldPath]);
                    if(! _.isArray(oldVideos) || ! oldVideos.length) return videos;
                    const oldById = _.keyBy(oldVideos.filter(v => v && v.id), "id");
                    // The poster is the one exception: it is uploaded after the video exists,
                    // so it can be added, replaced or removed. Only its identifying
                    // properties are kept, and its uploader comes from the session.
                    const contextUser = this.options.context && this.options.context.user;
                    return (_.isArray(videos) ? videos : []).map(v => {
                        const old = v && v.id && oldById[v.id];
                        if(! old) return v;
                        const poster = v.poster;
                        if(! _.isPlainObject(poster)) return {...old, poster: null};
                        const unchanged = old.poster && old.poster.id === poster.id;
                        const user = unchanged ? old.poster.user : (contextUser ? {id: contextUser.id, name: contextUser.name} : undefined);
                        return {...old, poster: {..._.pick(poster, ['id', 'name', 'type', 'date']), user}};
                    });
                }]}
            },
            {type: "Profile", link: "MTM"},
            {path: "tags", type: "MediaTag", link: "MTM", nullable: true},
            {path: "order", type: "integer", nullable: true},
            //{path: "fullWidth", type: "boolean", nullable: true},
            {path: "showDescription", type: "boolean", nullable: true},
            {path: "showTags", type: "boolean", nullable: true},

            {path: "includedInLatestNewsList", type: "boolean", nullable: true},
            {type: "Language", link: "MTM"},
            'FileType',
            {
                path: "documentsToShowInNavBar",
                type: "UploadedFileName",
                link: 'OTM',
                nullable: true
            },
            {
                path: "numberOfDocumentsToShowInNavBar",
                type: 'integer',
                $f: function (object, context, callback) {
                    callback(null, object.documentsToShowInNavBar?.length || 0)
                }
            },
            {
                path: 'filesToConsult',
                type: 'UploadedFileName',
                link: 'OTM',
                nullable: true
            },
            {
                path: "filesToConsult2",
                fieldPath: ['filesToConsult.id', 'filesToConsult.filename', 'filesToConsult.user.id', 'filesToConsult.user.name', 'filesToConsult.date', 'filesToConsult.type'],
                $f: function (object, context, callback) {
                    callback(null, object.filesToConsult)
                }
            },
            {
                path: "numberOfFilesToConsult",
                type: 'integer',
                $f: function (object, context, callback) {
                    callback(null, object.filesToConsult?.length || 0)
                }
            },
            {
                path: 'filesToShowInHomePage',
                type: 'UploadedFileName',
                nullable: true,
                link: 'OTM',
            },
            {
                path: "numberOfFilesToShowInHomePage",
                type: 'integer',
                $f: function (object, context, callback) {
                    callback(null, object.filesToShowInHomePage?.length || 0)
                }
            },
            {type: 'WidthOption', nullable: true},
            "MediaStatus",
            {
                path: "mediaType",
                fieldPath: ['fileType.id'],
                f: function() {
                    switch (this.fileType?.id) {
                        case 'doc' :
                            return 'documentIcon'
                        case 'img' :
                            return 'imageIcon'
                        case 'vid' :
                            return 'videoIcon'
                        default :
                            return ''
                    }
                }
            },
            {
                path: "orangeStyledRow",
                fieldPath: ["keepUntilDate", "lastUpdate"],
                $f: function (object, context, callback) {
                    return callback(null, isObjectExpired(object));
                }
            },
            {
                path: 'buttons',
                fieldPath: ["keepUntilDate", "lastUpdate"],
                $f: function (object, context, callback) {
                    const module = context.clientContext && context.clientContext.moduleId
                    const isUserModule = module === `m-${context.model.id}-mediaBaseUser`

                    const buttons = isUserModule ?
                        [returnButton]
                        : isObjectExpired(object) ?
                            [generateKeepForOneYearButton(object.keepUntilDate), saveButton, returnButton] : [saveButton, returnButton]

                    callback(null, buttons);
                }
            },
        ],
        filters: [
            {
                name: "byDocumentType",
                tKey: 'mediaTag',
                isDefault: false,
                client: true,
                path: 'documentType',
                default: [],
                object: 'MediaTag',
                display: 'name',
                type: 'tags',
                translateName: true,
                filters: ['byUser'],
                query: function(context) {
                    const documentTypes = _.get(context.data, 'documentType') || []
                    return !!documentTypes.length ? {"tags": {$elemMatch : {$in : documentTypes.map(type => new global.ObjectID(type.id))}}} : {}
                }
            },
            {
                name: "onlyActiveStatus",
                isDefault: false,
                query: function(context) {
                    return {"mediaStatus": {$eq: 'act' }}
                }
            },
            {
                name: "byLanguage",
                isDefault: false,
                query: function(context) {
                    return {languages: {$elemMatch: {$eq: context.user.language?.id}}}
                }
            },
            {
                name: "byProfile",
                isDefault: false,
                query: function(context) {
                    const userProfilesIds = context.userModel.profiles.map(obj => new global.ObjectID(obj.id))
                    return {profiles: {$elemMatch: {$in: userProfilesIds}}}
                }
            },
            {
                name: "consultableFiles",
                isDefault: false,
                query: function(context) {
                    return {filesToConsult: {$exists: true, $not: { $size: 0 } }}
                }
            }
        ],
        get: function(id, context, callback) {
            this.prepareContext(context, 'R', (error, context) => {
                if (error) callback(error)
                else {
                    const module = context.clientContext && context.clientContext.moduleId
                    const isUserModule = module === `m-${context.model.id}-mediaBaseUser`

                    global.app[context.model.id].MediaBase.find({
                        ...basicContext(context),
                        fieldPath: [
                            'title', 'description',
                            'profiles',
                            'languages', 'fileType', 'widthOption', 'mediaStatus', 'lastUpdatedBy',
                            'files.id', 'files.name', 'files.user.id', 'files.user.name', 'files.date', 'files.type',
                            'comments.id', 'comments.text', 'comments.user.id', 'comments.user.name', 'comments.date',
                            'images.id', 'images.name', 'images.user.id', 'images.user.name', 'images.date', 'images.type',
                            'videos.id', 'videos.name', 'videos.user.id', 'videos.user.name', 'videos.date', 'videos.type', 'videos.poster.id', 'videos.poster.name', 'videos.poster.date',
                            'tags',
                            'filesToConsult.id', 'filesToConsult.filename', 'filesToConsult.user.id', 'filesToConsult.user.name', 'filesToConsult.date', 'filesToConsult.type',
                            'filesToConsult2.id', 'filesToConsult2.filename', 'filesToConsult2.user.id', 'filesToConsult2.user.name', 'filesToConsult2.date', 'filesToConsult2.type',
                            'filesToShowInHomePage.id', 'filesToShowInHomePage.filename', 'filesToShowInHomePage.user.id', 'filesToShowInHomePage.user.name', 'filesToShowInHomePage.type', 'filesToShowInHomePage.poster.id', 'filesToShowInHomePage.poster.name', 'filesToShowInHomePage.poster.date',
                            'imagesForFiles.id', 'imagesForFiles.name', 'imagesForFiles.user.id', 'imagesForFiles.user.name', 'imagesForFiles.date', 'imagesForFiles.type',
                            'documentsToShowInNavBar.id', 'documentsToShowInNavBar.filename',
                            'buttons'
                        ],
                        query: {
                            _id: new global.ObjectID(id)
                        }
                    }, (e, elements) => {
                        if(e) return callback(e)
                        return callback(null,
                            isUserModule
                                ? {
                                    ...elements[0],
                                    media: [
                                        ...elements[0].videos.map(video => ({...video, type: 'video'})),
                                        ...elements[0].images.map(image => ({...image, type: 'image'}))
                                    ],
                                    //buttons: []
                                }
                                : elements[0]
                        )
                    })
                }
            })
        },
        /*onlyOneDocumentInHomePage: function(newObject, oldObject, context, callback) {
            if (newObject.fileType.id === 'doc'){
                if (newObject.filesToShowInHomePage.length > 1){
                    return callback(new Errors.ValidationError("MULTIPLE_DOCUMENTS_NOT_ALLOWED_IN_HOME_PAGE_FIELD"))
                }
            }
            callback()
        },*/
        /*validateSave: function(newObject, oldObject, context, callback) {
            async.series([
                //callback => this.validation1(newObject, oldObject, context, callback),
                callback => this.onlyOneDocumentInHomePage(newObject, oldObject, context, callback),
            ], callback)
        },*/
        beforeSave: (object, oldObject, context, callback) => {
            const action  = context.restAction && context.restAction.crudType
            if(action === 'C') {
                object.createdAt = new Date()
            }

            const buttonAction = context.action
            const authorizationToThisAction = isObjectExpired(object)

            if (buttonAction === 'keepForOneYear'){
                if (!authorizationToThisAction) {
                    return callback(new Errors.ValidationError('keepForOneYearDenied'))
                }
                let nextDate = moment(oldObject.keepUntilDate)


                while (nextDate.isValid() && !nextDate.isAfter(moment())) {
                    nextDate.add(1, 'year')
                }

                object.keepUntilDate = nextDate.toDate()

                object.comments.push({
                    user: _.pick(context.user, ['id', 'name']),
                    text: `Rappel demandé à partir du ${moment(object.keepUntilDate).format('DD-MM-YYYY')}`,
                    date: moment().format("YYYY-MM-DD HH:mm")
                })
            } else if (buttonAction === 'save') {
                const medias = [...(object.files || []),  ...(object.videos || []),  ...(object.images || [])]
                const lastUploadDate = moment.max(medias.map(obj => moment(obj.date))).toDate()
                object.keepUntilDate = moment(lastUploadDate).add(3, 'year').toDate();
            }

            object.lastUpdate = new Date()
            object.lastUpdatedBy = _.pick(context.user, ['id', 'name'])

            callback(null, object, oldObject)
        }
    },
]

export const modules = () =>[
    {
        tKey: 'm-T-MediaTag',
        object: 'MediaTag',
        category: {
            path: 'menuTitle_communication',
            icon: 'speech'
        },
        objectIdentifier: 'name',
        defaultSortBy: 'name',
        defaultSortDirection: 'ASC',
        viewMap: {
            dt: [
                {path: 'name', translateName: true}
            ],
            form: [
                {path: 'name', type: 'textarea', placeholder: 'fr:: nom en français\nen:: nom en Anglais'}
            ]
        }
    },
    {
        object: "MediaBase",
        name: 'MediaBaseAdmin',
        tKey: "mTitle-mediaBaseAdmin",
        category: {
            path: 'menuTitle_communication',
            icon: 'speech'
        },
        defaultSortBy: "lastUpdate",
        defaultSortDirection: "DESC",
        showNotificationCount: false,
        viewMap: {
            dt: [
                {path: "mediaType", tKey: 'media', type: 'icon', label: 'media', flexGrow: 0, notDraggable: true, width: 100},
                {path: "title", translateName: true, width: 250},
                'languages',
                {path: "profiles", tKey: "profile(s)", translateName: true, width: 300},
                {path: "tags", translateName: true, width: 250},
                {path: "numberOfDocumentsToShowInNavBar", tKey: "navigationBarNumber"},
                {path: 'numberOfFilesToConsult', tKey: 'mediaConsultationNumber'},
                {path: 'numberOfFilesToShowInHomePage', tKey: "homePageNumber"},
                {path: "order", width: 100},
                {path: 'widthOption', tKey: "displayWidth", initiallyNotVisible: true, translateName: true},
                {path: "showDescription", tKey: 'showPresentation', width: 200, initiallyNotVisible: true},
                {path: "showTags", tKey: 'showTags', width: 200, initiallyNotVisible: true},
                {path: 'mediaStatus', tKey: 'status'},
                {path: 'lastUpdatedBy', tKey: 'lastUpdateBy'},
                {path: "lastUpdate", width: 200},
                {path: 'keepUntilDate', initiallyNotVisible: true},
                {path: 'orangeStyledRow', hidden : true}
                //{path: 'lastFile', tKey: 'document', type: 'fileLink'},
                //{path: "includedInLatestNewsList"},
            ],
            form: {
                fields : [
                {path: "title", type: 'textarea', placeholder: 'fr:: nom en français\nen:: nom en Anglais', required: true},
                {path: "description", tKey: 'presentation', type: "richTextEditor"},
                {
                    path: "languages",
                    required: true,
                    $default: (context) => {
                        switch (context?.groupModel?.model?.id) {
                            case 'C': //for cnda
                                return [{ id: 'fr' }]
                            default: //for others (only CSE for now)
                                return [{ id: 'fr' }, { id: 'en' }]
                        }
                    }
                },
                {path: "profiles", tKey: "profile(s)", translateName: true, filters: ["thisModel"]},
                {path: "tags", required: true, translateName: true},
                {
                    path: 'fileType',
                    tKey: 'mediaType',
                    editable: false,
                    required: true,
                    clearable: false,
                    default: {id: 'doc'},
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, module, formInitialize, getObjectSuccessAction}) => {
                            const videosField = module.viewMap.form.fields.find(field => field.path === 'videos')
                            const imagesField = module.viewMap.form.fields.find(field => field.path === 'images')
                            const filesField = module.viewMap.form.fields.find(field => field.path === 'files')
                            const imagesForFilesField = module.viewMap.form.fields.find(field => field.path === 'imagesForFiles')
                            const documentsToShowInNavBarField = module.viewMap.form.fields.find(field => field.path === 'documentsToShowInNavBar')

                            store.dispatch(setFieldVisibility(videosField.id, newValue?.id === 'vid'))
                            store.dispatch(setFieldVisibility(imagesField.id, newValue?.id === 'img'))
                            store.dispatch(setFieldVisibility(filesField.id, newValue?.id === 'doc'))
                            store.dispatch(setFieldVisibility(imagesForFilesField.id, newValue?.id === 'doc'))
                            store.dispatch(setFieldVisibility(documentsToShowInNavBarField.id, newValue?.id === 'doc'))

                            if (formInitialize || getObjectSuccessAction) return

                            if (newValue?.id === 'vid'){
                                imagesField.setValue([])
                                filesField.setValue([])
                                imagesForFilesField.setValue([])
                            }
                            if (newValue?.id === 'img'){
                                videosField.setValue([])
                                filesField.setValue([])
                                imagesForFilesField.setValue([])
                            }
                            if (newValue?.id === 'doc'){
                                videosField.setValue([])
                                imagesField.setValue([])
                            }
                        }
                    }
                },
                {
                    path: "videos",
                    type: 'video',
                    fieldPath: ['id', 'name', 'type', 'user.id', 'user.name', 'date', 'poster.id', 'poster.name', 'poster.type', 'poster.user.id', 'poster.user.name', 'poster.date'],
                    required: true,
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, module, formInitialize, getObjectSuccessAction}) => {

                            if (formInitialize || getObjectSuccessAction) return

                            const filesToConsultField = module.viewMap.form.fields.find(field => field.path === 'filesToConsult')
                            const filesToShowInHomePageField = module.viewMap.form.fields.find(field => field.path === 'filesToShowInHomePage')

                            const filesToConsult = filesToConsultField && filesToConsultField.getValue()
                            const filesToShowInHomePage = filesToShowInHomePageField && filesToShowInHomePageField.getValue()

                            const uploadedFilesNames = (newValue || []).map(vid => {
                                    return {
                                        id: vid.id,
                                        filename: vid.name,
                                        type: 'video',
                                        user: vid.user,
                                        date: vid.date,
                                        poster: vid.poster,
                                    }
                                })

                            store.dispatch(setDataList(
                                'filesToConsult',
                                    //'m-R-mediaBaseAdmin.MediaBase_filesToConsult',
                                    uploadedFilesNames
                                )
                            )
                            store.dispatch(setDataList(
                                    'filesToShowInHomePage',
                                    //'m-R-mediaBaseAdmin.MediaBase_filesToConsult',
                                    uploadedFilesNames
                                )
                            )
                            store.dispatch(setDataList(
                                    'documentsToShowInNavBar',
                                    //'m-R-mediaBaseAdmin.MediaBase_filesToConsult',
                                    uploadedFilesNames
                                )
                            )

                            const updatedFilesToConsult = (filesToConsult || []).map(file => {
                                // Find the corresponding latest version in uploadedFilesNames
                                const latestVersion = uploadedFilesNames.find(uploadedFile => uploadedFile.id === file.id);

                                // If a newer version exists, return it; otherwise, keep the original
                                return latestVersion ? latestVersion : file
                            })
                            const updatedFilesToShowInHomePage = (filesToShowInHomePage || []).map(file => {
                                // Find the corresponding latest version in uploadedFilesNames
                                const latestVersion = uploadedFilesNames.find(uploadedFile => uploadedFile.id === file.id);

                                // If a newer version exists, return it; otherwise, keep the original
                                return latestVersion ? latestVersion : file
                            })
                            filesToConsultField.setValue(updatedFilesToConsult)
                            filesToShowInHomePageField.setValue(updatedFilesToShowInHomePage)
                        }
                    }


                },
                {
                    path: "images",
                    type: 'image',
                    fieldPath: ['id', 'name', 'type', 'user.id', 'user.name', 'date'],
                    required: true,
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, formInitialize, getObjectSuccessAction}) => {
                            if (formInitialize || getObjectSuccessAction) return

                            const uploadedFilesNames = (newValue || []).map(img => {
                                return {
                                    id: img.id,
                                    filename: img.name,
                                    type: 'image',
                                    user: img.user,
                                    date: img.date
                                }
                            })

                            store.dispatch(setDataList(
                                'filesToConsult',
                                    //'m-R-mediaBaseAdmin.MediaBase_filesToConsult',
                                    uploadedFilesNames
                                )
                            )
                            store.dispatch(setDataList(
                                    'filesToShowInHomePage',
                                    //'m-R-mediaBaseAdmin.MediaBase_filesToConsult',
                                    uploadedFilesNames
                                )
                            )
                            store.dispatch(setDataList(
                                    'documentsToShowInNavBar',
                                    //'m-R-mediaBaseAdmin.MediaBase_filesToConsult',
                                    uploadedFilesNames
                                )
                            )

                        }
                    }


                },
                {
                    path: "files",
                    tKey: 'document(s)',
                    placeholder: 'addDocument(s)',
                    required: true,
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, formInitialize, getObjectSuccessAction}) => {
                            if (formInitialize || getObjectSuccessAction) return

                            const uploadedFilesNames = (newValue || []).map(file => {
                                return {
                                    id: file.id,
                                    filename: file.filename,
                                    type: 'document',
                                    user: file.user,
                                    date: file.date
                                }
                            })

                            store.dispatch(setDataList(
                                'filesToConsult',
                                    uploadedFilesNames
                                )
                            )
                            store.dispatch(setDataList(
                                    'filesToShowInHomePage',
                                    uploadedFilesNames
                                )
                            )
                            store.dispatch(setDataList(
                                    'documentsToShowInNavBar',
                                    uploadedFilesNames
                                )
                            )
                        }
                    }
                },
                {
                    path: "imagesForFiles",
                    type: 'image',
                    fieldPath: ['id', 'name', 'type', 'user.id', 'user.name', 'date'],
                    tKey: 'presentationImage',
                    placeholder: 'addPresentationImage',
                    singleImage: true
                },
                {
                    path: "documentsToShowInNavBar",
                    fieldPath: ['id', 'filename'],
                    display: 'filename',
                    tKey: "showInNavigationBar",
                    type: 'tags',
                    access: {
                        id: 'documentsToShowInNavBar',
                        entity: {
                            url: 'documentsToShowInNavBar1'
                        }
                    }
                },
                {
                    path: 'filesToConsult',
                    tKey: 'showInConsultationMedia',
                    fieldPath: ['id', 'filename', 'user.id', 'date', 'type', 'poster'],
                    display: 'filename',
                    type: 'tags', //simpleFiles files2 singleFile
                    access: {
                        id: 'filesToConsult',
                        entity: {
                            url: 'filesToConsult1'
                        }
                    }
                },
                {
                    path: 'filesToShowInHomePage',
                    tKey: 'showInHomePage',
                    display: 'filename',
                    fieldPath: ['id', 'filename', 'user.id', 'date', 'type', 'poster'],
                    type: 'tags',
                    access: {
                        id: 'filesToShowInHomePage',
                        entity: {
                            url: 'filesToShowInHomePage1'
                        }
                    },
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, module}) => {
                            const widthOptionsField = module.viewMap.form.fields.find(field => field.path === 'widthOption')
                            const orderField = module.viewMap.form.fields.find(field => field.path === 'order')
                            const showDescriptionField = module.viewMap.form.fields.find(field => field.path === 'showDescription')
                            const showTagsField = module.viewMap.form.fields.find(field => field.path === 'showTags')
                            store.dispatch(setFieldVisibility(widthOptionsField.id, !!newValue?.length))
                            store.dispatch(setFieldVisibility(orderField.id, !!newValue?.length))
                            store.dispatch(setFieldVisibility(showDescriptionField.id, !!newValue?.length))
                            store.dispatch(setFieldVisibility(showTagsField.id, !!newValue?.length))
                        }
                    }
                },
                {path: "order", tKey: "displayOrder", required: true, default: 1},
                {path: 'widthOption', tKey: "displayWidth", default: {id: 'full'}, required: true, translateName: true},
                //{path: "fullWidth", default: false},
                {path: "showDescription", tKey: 'showPresentation'},
                {path: "showTags", tKey: 'showTags', default: false},
                'comments',
                {path: 'mediaStatus', tKey: 'status', default: { id: 'act', name: 'actif' }, type: 'toggle', required: true},
                //{path: "includedInLatestNewsList"},
                { path: 'buttons', hidden: true }
                ],
            }
        },
        actionSubscriptions: [
            {
                actionType: CREATE_OBJECT_SUCCESS,
                subscription: ({ store }) => {
                    const state = store.getState()
                    const moduleId = _.get(state, 'module.id')
                    store.dispatch(fetchDtData(moduleId))
                }
            },
            {
                actionType: SAVE_OBJECT_SUCCESS,
                subscription: ({ store }) => {
                    const state = store.getState()
                    const moduleId = _.get(state, 'module.id')
                    store.dispatch(fetchDtData(moduleId))
                }
            },
            {
                actionType: GET_OBJECT_SUCCESS,
                subscription: ({ store }) => {
                    const state = store.getState()
                    console.log('object', state.edit.object.data)
                    const files = state.edit.object.data.files
                    const images = state.edit.object.data.images
                    const videos = state.edit.object.data.videos

                    const uploadedFilesNames = [
                        ...files.map(file => {
                            return {
                                id: file.id,
                                filename: file.filename,
                                type: 'document',
                                user: file.user,
                                date: file.date
                            }
                        }),
                        ...images.map(img => {
                            return {
                                id: img.id,
                                filename: img.name,
                                type: 'image',
                                user: img.user,
                                date: img.date
                            }
                        }),
                        ...videos.map(vid => {
                            return {
                                id: vid.id,
                                filename: vid.name,
                                type: 'video',
                                user: vid.user,
                                date: vid.date,
                                poster: vid.poster
                            }
                        })
                    ]

                    store.dispatch(setDataList(
                            'filesToConsult',
                            uploadedFilesNames
                        )
                    )
                    store.dispatch(setDataList(
                            'filesToShowInHomePage',
                            uploadedFilesNames
                        )
                    )
                    store.dispatch(setDataList(
                            'documentsToShowInNavBar',
                            uploadedFilesNames
                        )
                    )
                }
            }
        ],
        filters: ['byDocumentType']
    },
    {
        object: "MediaBase",
        name: 'MediaBaseUser',
        tKey: "mTitle-mediaBaseUser",
        category: {
            path: 'menuTitle_communication',
            icon: 'speech'
        },
        newable: false,
        removable: false,
        buttonContainerStyle: {maxWidth: '700px', margin: '20px auto', padding: 0},
        viewMap: {
            dt: [
                {path: "mediaType", tKey: 'media', type: 'icon', label: 'media', flexGrow: 0, notDraggable: true, width: 65},
                {path: "title", translateName: true, width: 250},
                {path: "tags", translateName: true, width: 250},
                {path: "numberOfDocumentsToShowInNavBar", tKey: "navigationBarNumber"},
                {path: 'numberOfFilesToConsult', tKey: 'mediaConsultationNumber'},
                {path: 'numberOfFilesToShowInHomePage', tKey: "homePageNumber"},
                {path: 'lastUpdatedBy', tKey: 'lastUpdateBy', initiallyNotVisible: true},
                {path: "lastUpdate", width: 200},
                //{path: 'lastFile', tKey: 'document', type: 'fileLink'},
                //{path: "visible", width: 100}
            ],
            form:
                [
                    {path: "title", type: 'textarea', editable: false, readOnly: true, style: {maxWidth: '700px', margin: 'auto', letterSpacing: '-0.011em', lineHeight: '32px', fontSize: '25px', color: '#00b1f0'}, userGroupSelectedColor: true},
                    {path: "tags", translateName: true, editable: false, readOnly: true, style: {maxWidth: '700px', margin: '-20px auto 0'}},
                    {
                        path: 'fileType',
                        tKey: 'mediaType',
                        hidden: true,
                        editable: false,
                        required: true,
                        clearable: false,
                        default: {id: 'doc'},
                        subscriptions: {
                            onChange: (newValue, oldValue, {store}) => {
                                const mediaType = newValue?.id === 'doc' ? 'files2' : 'media'

                                store.dispatch(setFieldVisibility("e_filesToConsult", mediaType === 'media'))
                                store.dispatch(setFieldVisibility("e_filesToConsult2", mediaType === 'files2'))
                                store.dispatch(setFieldVisibility("e_imagesForFiles", mediaType === 'files2'))
                            }
                        }
                    },
                    {
                        path: 'filesToConsult',
                        tKey: '',
                        type: 'media',
                        editable: false,
                        fieldPath: ['id', 'filename', 'type', 'user.id', 'user.name', 'date', 'poster.id', 'poster.date', 'poster.name'],
                        containerStyle: {maxWidth: '700px', margin: 'auto'}
                    },
                    {
                        path: 'imagesForFiles',
                        tKey: '',
                        type: 'media',
                        editable: false,
                        fieldPath: ['id', 'name', 'type', 'user.id', 'user.name', 'date'],
                        containerStyle: {maxWidth: '700px', margin: 'auto'}
                    },
                    {path: "description", tKey: 'presentation', type: "richTextEditor", editable: false, readOnly: true, style: {maxWidth: '730px', margin: 'auto', fontSize: '14px', letterSpacing: '0.03em'}},
                    {
                        path: 'filesToConsult2',
                        tKey: 'document(s)',
                        type: 'files2',
                        editable: false,
                        fieldPath: ['id', 'filename', 'type', 'user.id', 'user.name', 'date'],
                        style: {maxWidth: '700px', margin: 'auto'}
                    },
                    {path: 'buttons', hidden: true},
                ],
        },
        filters: ['byDocumentType', 'onlyActiveStatus', 'byProfile', 'consultableFiles', 'byLanguage']
    }
]
